// ImageList.js
import MediaList from './MediaList';
import { Tooltip } from 'antd';
import { Link } from 'react-router-dom';

function ImageList() {
	const columns = [
		{
			title: <div className="text-base">Chapter</div>,
			dataIndex: 'chapter_id',
			key: 'chapter_id',
			align: 'center',
			width: '10%',
			sorter: (a, b) => a.chapter_id - b.chapter_id,
		},
		{
			title: <div className="text-base">Title (No. of images)</div>,
			dataIndex: 'chapter_name',
			key: 'chapter_name',
			width: '80%',
			render: (chapter_name, record) => (
				<Tooltip title={chapter_name}>
					<Link
						to={`/get-chapter-images/${record.chapter_id}`}
						state={{ chapterId: record.chapter_id, entireRec: record }}
						className="linkColor"
					>
						<span className="mr-2 text-sm">{chapter_name}</span>
						<span className="italic font-semibold text-sm">
							({record.total_count})
						</span>
					</Link>
				</Tooltip >
			),
		},
	];
	return (
		<MediaList
			apiEndpoint="/images-list"
			column={columns}
			pageTitle="IMAGE LIST"
			linkPrefix="/get-chapter-images"
			crumbLabel="Images"
		/>
	);
}

export default ImageList;
